<template>
  <div class="agora-advanced-json">
    <div class="agora-advanced-json__head">
      <span class="agora-advanced-json__title">自定义 JSON</span>
      <Button type="text" icon="ios-refresh" :loading="loading" @click="load">重新获取</Button>
    </div>

    <Input
      v-model="jsonText"
      type="textarea"
      :rows="18"
      :disabled="loading || saving"
      placeholder="请输入合法 JSON"
      class="agora-advanced-json__input"
    />
    <p v-if="errorMessage" class="agora-advanced-json__error">{{ errorMessage }}</p>
    <div class="agora-advanced-json__footer">
      <Button type="primary" :loading="saving" :disabled="loading" @click="save">保存</Button>
    </div>
  </div>
</template>

<script>
import { getAgoraAdvancedJsonA, saveAgoraAdvancedJsonA } from '@/server/api'

export default {
  name: 'AgoraAdvancedJsonSection',
  props: {
    sceneId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      jsonText: '{}',
      loading: false,
      saving: false,
      errorMessage: '',
    }
  },
  watch: {
    sceneId() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    normalizedSceneId() {
      const id = Number(this.sceneId)
      return Number.isFinite(id) && id > 0 ? id : this.sceneId
    },
    load() {
      const sceneId = this.normalizedSceneId()
      if (!sceneId) return
      this.loading = true
      this.errorMessage = ''
      getAgoraAdvancedJsonA({ sceneId })
        .then((res) => {
          if (!res || res.code !== 200) {
            throw new Error((res && res.message) || '获取自定义 JSON 失败')
          }
          const advancedJson = res.data && res.data.advanced_json
          this.jsonText = JSON.stringify(
            advancedJson && typeof advancedJson === 'object' && !Array.isArray(advancedJson)
              ? advancedJson
              : {},
            null,
            2,
          )
        })
        .catch((error) => {
          this.errorMessage = error && error.message ? error.message : '获取自定义 JSON 失败'
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      let advancedJson
      try {
        advancedJson = JSON.parse(this.jsonText || '{}')
      } catch (error) {
        this.errorMessage = 'JSON 格式不正确，请检查后再保存'
        return
      }
      if (!advancedJson || typeof advancedJson !== 'object' || Array.isArray(advancedJson)) {
        this.errorMessage = '自定义 JSON 必须是对象'
        return
      }

      const sceneId = this.normalizedSceneId()
      if (!sceneId) return
      this.saving = true
      this.errorMessage = ''
      saveAgoraAdvancedJsonA({ sceneId, advanced_json: advancedJson })
        .then((res) => {
          if (!res || res.code !== 200) {
            throw new Error((res && res.message) || '保存自定义 JSON 失败')
          }
          this.$Message.success('保存成功')
        })
        .catch((error) => {
          this.errorMessage = error && error.message ? error.message : '保存自定义 JSON 失败'
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.agora-advanced-json {
  text-align: left;
}

.agora-advanced-json__head,
.agora-advanced-json__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.agora-advanced-json__head {
  margin-bottom: 12px;
}

.agora-advanced-json__title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}

.agora-advanced-json__input {
  ::v-deep textarea {
    font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.6;
    background: #fff;
  }
}

.agora-advanced-json__error {
  margin: 8px 0 0;
  color: #ed4014;
  font-size: 12px;
}

.agora-advanced-json__footer {
  justify-content: flex-end;
  margin-top: 12px;
}
</style>
